import './bootstrap'
import './polyfill-repeat'
import axios from 'axios'
import pageAccidentReportForm from './pages/accident-report/form'

// 設定
const el = document.querySelector('meta[name="csrf-token"]')
axios.defaults.headers.common['X-CSRF-TOKEN'] = el ? el.getAttribute('content') : null

// ページ別
const pages = {
    accidentReport: {
        form: pageAccidentReportForm,
    },
}

window.App = {pages}
